import { z } from "zod";

import type { AccountDetails, TaxCode } from "@/apis/gql/types";
import { AddBookingForm } from "@/components/shared/bookings/add-booking-form";

import { UpdateInvoiceFields, useSaveInvoice } from "../../ReviewProvider";

import type { InvoiceModes } from "../SplitInvoiceForm";

export interface AddLineItemBarProps {
  accounts: AccountDetails[] | undefined;
  taxCodes: TaxCode[] | undefined;
  rowCount: number;
  invoiceMode: InvoiceModes;
}

const addLineItemFormSchema = z.object({
  name: z.string().max(255).optional().nullable(),
  accountId: z.string().max(255),
  taxCodeId: z.string().max(255).nullable(),
  costCenterId: z.string().max(255).nullable().optional(),
  amount: z.number({ message: "Umsatz darf nicht leer sein" }),
});

type AddLineItemFrom = z.infer<typeof addLineItemFormSchema>;

export const AddLineItemBar = ({
  rowCount,
  invoiceMode,
}: AddLineItemBarProps) => {
  const { saveInvoice } = useSaveInvoice();

  const handleSubmit = async ({
    name,
    accountId,
    taxCodeId,
    costCenterId,
    amount,
  }: AddLineItemFrom) => {
    await saveInvoice(UpdateInvoiceFields.CreateLineItem, {
      name,
      accountId,
      bookingTextManuallyUpdated: true,
      taxCodeId,
      costCenterId,
      amount,
      index: rowCount,
    });

    setTimeout(() => {
      const element = document.getElementById("invoice-details-panel");
      if (element) {
        element.scrollTop = element.scrollHeight;
      }
    }, 300);
  };

  return <AddBookingForm onSubmit={handleSubmit} invoiceMode={invoiceMode} />;
};
